export function showToast(msg: string, type: "success" | "error" = "success") {
  const el = document.createElement("div")
  el.textContent = msg
  el.className = `fixed top-4 right-4 z-[9999] rounded-lg px-4 py-3 text-sm font-medium shadow-lg ${
    type === "error"
      ? "bg-red-900/90 text-red-200 border border-red-700"
      : "bg-green-900/90 text-green-200 border border-green-700"
  }`
  document.body.appendChild(el)
  setTimeout(() => el.remove(), 5000)
}
